import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps } from '@progress/kendo-react-grid'
import { Tag } from 'antd'
import { GridColumn } from 'routes/Transactions/transactionIBTransactionsColumns'

export const rebatePoliciesColumns: GridColumn[] = [
  {
    title: 'IB Entity',
    field: 'ibEntity',
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td>
          <CompanyTag id={props.dataItem.ibEntity.id}>{props.dataItem.ibEntity.name}</CompanyTag>
        </td>
      )
    },
    resizable: true,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 400,
  },
  {
    title: 'Client Entity',
    field: 'clientEntity',
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td>
          <CompanyTag id={props.dataItem.clientEntity.id}>
            {props.dataItem.clientEntity.name}
          </CompanyTag>
        </td>
      )
    },
    resizable: true,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 400,
  },
  {
    title: 'Relation Allowed',
    field: 'isRelationAllowed',
    cell: (props: GridCellProps) => {
      const isRelationAllowed = props.dataItem.isRelationAllowed || false
      return (
        <td>
          <Tag>{isRelationAllowed ? 'Yes' : 'No'}</Tag>
        </td>
      )
    },
    resizable: true,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 400,
  },
]
